import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-group-content',
  standalone: true,
  imports: [],
  templateUrl: './group-content.component.html',
  styleUrl: './group-content.component.scss',
})
export class GroupContentComponent {
  @Input() contentType: 'creatives' | 'chart' | 'table' = 'creatives';
}
